import React, { useState } from "react"
import { Select, Space, Input, DatePicker } from "antd"

const PayoutFilters = ({ filters, onFiltersChange }) => {
  const [searchField, setSearchField] = useState("remark")
  const searchBy = (
    <Select defaultValue="remark" className="select-before" onChange={value => setSearchField(value)}>
      <Select.Option value="remark">Remark</Select.Option>
      <Select.Option value="userEmail">User Email</Select.Option>
      <Select.Option value="transactionNo">Transaction No</Select.Option>
      <Select.Option value="id">Payout ID</Select.Option>
      <Select.Option value="trackingNo">Tracking Number</Select.Option>
    </Select>
  );

  return (
    <Space size="large" wrap>
      <div>
        <DatePicker.RangePicker
          value={[filters.startDate, filters.endDate]}
          onChange={dates => (dates
            ? onFiltersChange({ ...filters, startDate: dates[0], endDate: dates[1] })
            : onFiltersChange({ ...filters, startDate: undefined, endDate: undefined })
          )}
        />
      </div>

      <div>
        <Input.Search
          addonBefore={searchBy}
          placeholder="Search"
          onSearch={term => onFiltersChange({ ...filters, search: term, searchField })}
        />
      </div>

      <div>
        Status :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 120 }}
          allowClear
          onChange={value => onFiltersChange({ ...filters, status: value })}
        >
          <Select.Option value="success">Success</Select.Option>
          <Select.Option value="failed">Failed</Select.Option>
          <Select.Option value="pending">Pending</Select.Option>
          <Select.Option value="cancelled">Cancelled</Select.Option>
        </Select>
      </div>


      <div>
        Payment Provider :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 120 }}
          allowClear
          onChange={value => onFiltersChange({ ...filters, paymentProvider: value })}
        >
          <Select.Option value="paydibs">Paydibs</Select.Option>
          <Select.Option value="commercePay">CommercePay</Select.Option>
        </Select>
      </div>
    </Space>
  )
}

export default PayoutFilters;
